var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"release-title"},[_c('span',{staticClass:"product-name"},[_vm._v(_vm._s(_vm.release.product.name))]),_vm._v(" "),_c('release-tag',{attrs:{"release":_vm.release}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }